module.exports = __webpack_public_path__ + "static/img/head_3.823c9dbf.png";